export default __webpack_public_path__ + "static/design-elements-dark-e809998e6fad6eee579461327efe3510.svg";